import { PdpSpuType, orderTypes } from "./lynkco-constants";

export const measurementNames = {
  carName: "Lynk & Co 01",
  brandName: "Lynk & Co"
};

export const getCategories = unsortedCategories => {
  let categories = [];

  if (unsortedCategories && Array.isArray(unsortedCategories)) {
    let levels3 = unsortedCategories.filter(category => category.level === 3);
    levels3 &&
      levels3.forEach(level3 => {
        let level2 = unsortedCategories.find(category => category.categoryId === level3.parentId);
        let level1 = unsortedCategories.find(category => category.categoryId === level2.parentId);
        categories.push(`${level1.categoryName}|${level2.categoryName}|${level3.categoryName}`);
      });
  }
  return categories;
};

export const getProductByOrderPreview = orderPreview => {
  let product = "";
  let checkoutFlow = "";
  let financingType = "";
  let winterWheels = "no";

  if (!orderPreview) {
    return product;
  }
  switch (orderPreview.subType) {
    case orderTypes.monthToMonth:
      checkoutFlow = "month-to-month";
      break;
    case orderTypes.longTerm:
      checkoutFlow = "long-term";
      break;
    case orderTypes.buyACarLoan:
      checkoutFlow = "buy-car-loan";
      financingType = "loan";
      break;
    case orderTypes.buyACarCash:
      checkoutFlow = "buy-car-cash";
      financingType = "cash";
      break;
  }
  const orderItems = orderPreview.orderItems || orderPreview.suborders[0].orderItems;

  if (parseInt(orderPreview.orderExtraData?.isWithWinterWheels)) {
    winterWheels = orderItems?.find(item => item.tag === PdpSpuType.winterWheels);
    if (winterWheels?.skuVariants?.length > 0) {
      winterWheels = winterWheels?.skuVariants[0].value.toLowerCase().replace(" ", "-");
    } else {
      winterWheels = "winter-tires";
    }
  }

  const storage = orderItems?.find(item => item.tag === PdpSpuType.wheelsService);
  const vehicleItem = orderItems?.find(item => item.tag === PdpSpuType.vehicle);
  const vehicleSkus = vehicleItem.skuAttributeList || vehicleItem.skuVariants;

  product = {
    name: measurementNames.carName,
    id: orderPreview?.orderExtraData?.bundleId || orderPreview?.bundleId,
    price: orderPreview.orderExtraData?.loanTotalAmount ? orderPreview.orderExtraData?.loanTotalAmount : orderPreview.orderExtraData?.totalAmount,
    brand: measurementNames.brandName,
    category: "car",
    variant: vehicleSkus?.find(item => item.defaultLanguageLabel?.toLowerCase() === "color")?.defaultLanguageValue,
    engine: vehicleSkus?.find(item => item.defaultLanguageLabel?.toLowerCase() === "engine")?.defaultLanguageValue,
    membershipPlan: checkoutFlow,
    financingType: financingType,
    duration: orderPreview.orderExtraData?.loanPaymentMonthPeriod,
    mileage: "",
    winterWheels: winterWheels,
    downPayment: financingType === "cash" ? "" : orderPreview.orderExtraData?.loanDownPayment,
    towbar: parseInt(orderPreview.orderExtraData?.isWithTowbar) == 1 ? "yes" : "no",
    storage: storage ? "yes" : "no",
    subscriptionValue: orderPreview.orderExtraData?.totalMonthlyFee
  };

  return product;
};

export const getMembershipLevel = code => {
  let membershipLevel;
  switch (code) {
    case "MEMBERSHIP01":
      membershipLevel = "Level0";
      break;
    case "MEMBERSHIP02":
      membershipLevel = "Level1";
      break;
    case "MEMBERSHIP03":
      membershipLevel = "Level2";
      break;
    case "MEMBERSHIP04":
      membershipLevel = "Level3";
      break;
    default:
      membershipLevel = "";
      break;
  }

  return membershipLevel;
};
